import {Component, Inject, OnInit} from '@angular/core';
import {TestLinkService} from '../../../services/api/test-link.service';
import {FormBuilder} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TEST_LINK_VALIDATORS} from '../../../../constants/validators';
import {formatDate} from '@angular/common';
import {MatCheckboxChange} from '@angular/material/checkbox';
import { TestLink } from 'src/app/data/models/test-link';

@Component({
  selector: 'app-test-link-edit-dialog',
  templateUrl: './test-link-edit-dialog.component.html',
  styleUrls: ['./test-link-edit-dialog.component.css']
})
export class TestLinkEditDialogComponent implements OnInit {

  testLinkForm = this.fb.group({
    name: ['', TEST_LINK_VALIDATORS.NAME],
    mail: ['', TEST_LINK_VALIDATORS.MAIL],
    startDate: ['', TEST_LINK_VALIDATORS.START_DATE],
    finishDate: ['', TEST_LINK_VALIDATORS.FINISH_DATE],
    isMixedQuestions: [false, Boolean],
    isMixedOptions: [false, Boolean],
    allQuestionsRequired: [true, Boolean],
    trackTelegramUsers: [false, Boolean],
  });

  isFinishless = true;
  testId: number;
  testLink: TestLink;

  constructor(
    private testLinkService: TestLinkService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TestLinkEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { testId: number; testLink: TestLink},
  ) {
    this.testId = this.data.testId;
    this.testLink = this.data.testLink;

    this.testLinkForm.controls.name.setValue(this.data.testLink.name);
    this.testLinkForm.controls.mail.setValue(this.data.testLink.mail);
    this.testLinkForm.controls.startDate.setValue(new Date(this.data.testLink.startDate));
    this.testLinkForm.controls.finishDate.setValue(formatDate(new Date(this.data.testLink.finishDate), 'yyyy-MM-dd', 'ru'));
    this.testLinkForm.controls.isMixedQuestions.setValue(this.data.testLink.isMixedQuestions);
    this.testLinkForm.controls.isMixedOptions.setValue(this.data.testLink.isMixedOptions);
    this.testLinkForm.controls.allQuestionsRequired.setValue(
      this.data.testLink.allQuestionsRequired ?? true
    );
    this.testLinkForm.controls.trackTelegramUsers.setValue(
      this.data.testLink.trackTelegramUsers ?? false
    );

    this.testLinkForm.controls.mail.disable();

    if (this.testLinkForm.controls.finishDate.value == '9999-12-31') {
      this.setFinishless(true);
    } else {
      this.setFinishless(false);
    }
  }

  ngOnInit(): void {
  }

  setFinishless(isFinishless: boolean): void {
    this.isFinishless = isFinishless;
    if (isFinishless) {
      this.testLinkForm.controls.finishDate.setValue('9999-12-31');
      this.testLinkForm.controls.finishDate.disable();
    } else {
      this.testLinkForm.controls.finishDate.setValue(new Date(this.data.testLink.finishDate));
      this.testLinkForm.controls.finishDate.enable();
    }
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.testLinkForm.valid) {
      this.testLinkService.editTestLink(
        this.testId,
        this.testLink.id,
          {
            name: this.testLinkForm.controls.name.value,
            startDate: formatDate(this.testLinkForm.controls.startDate.value, 'yyyy-MM-dd', 'ru'),
            finishDate: formatDate(this.testLinkForm.controls.finishDate.value, 'yyyy-MM-dd', 'ru'),
            isMixedQuestions: this.testLinkForm.controls.isMixedQuestions.value,
            isMixedOptions: this.testLinkForm.controls.isMixedOptions.value,
            allQuestionsRequired: this.testLinkForm.controls.allQuestionsRequired.value,
            trackTelegramUsers: this.testLinkForm.controls.trackTelegramUsers.value
          }).then(testLink => this.dialogRef.close(testLink));
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onFinishlessChange(event: MatCheckboxChange): void {
    this.setFinishless(event.checked);
  }

  onMixedQuestionsChange(event: MatCheckboxChange): void {
    this.testLinkForm.controls.isMixedQuestions.setValue(event.checked);
  }

  onMixedOptionsChange(event: MatCheckboxChange): void {
    this.testLinkForm.controls.isMixedOptions.setValue(event.checked);
  }

  onAllQuestionsRequiredChange(event: MatCheckboxChange): void {
    this.testLinkForm.controls.allQuestionsRequired.setValue(event.checked);
  }

  onTrackTelegramUsersChange(event: MatCheckboxChange): void {
    this.testLinkForm.controls.trackTelegramUsers.setValue(event.checked);
  }
}
